import { api, TmrBaseResource, responseErrorCheck, ResourcePage, IdentifierReel } from 'stylewhere/api'

export class IdentifierReels extends TmrBaseResource {
  static endpoint = `/api/v1/identifierReels`

  static async search<T = IdentifierReel>(searchParams = {}): Promise<ResourcePage<T>> {
    return api.get<ResourcePage<T>>(`${this.endpoint}`, searchParams).then(responseErrorCheck)
  }
}
